import { Type } from "@sinclair/typebox";
import { CanonicalizationError } from "./canonical-json.js";
export const ContractVersion = "1";
export const ContractVersionHeader = "X-Carbon-Contract-Version";
export const OpaqueIdSchema = Type.String({ minLength: 1, maxLength: 128, pattern: "^[A-Za-z0-9][A-Za-z0-9_-]*$" });
// Identity-provider subjects are issued externally (e.g. Auth0 "auth0|…" users and
// "…@clients" machine clients), so they are not opaque product IDs. Same shape the
// onboarding CLI accepts: 1–240 characters, no whitespace or control characters.
export const SubjectIdSchema = Type.String({ minLength: 1, maxLength: 240, pattern: "^[^\\s\\u0000-\\u001f\\u007f]+$" });
export const IsoDateTimeSchema = Type.String({
    pattern: "^[0-9]{4}-(0[1-9]|1[0-2])-([0-2][0-9]|3[01])T([01][0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9](\\.[0-9]{1,9})?Z$",
});
const isoDateTime = /^([0-9]{4}-(?:0[1-9]|1[0-2])-(?:[0-2][0-9]|3[01])T(?:[01][0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9])(?:\.([0-9]{1,9}))?Z$/;
/**
 * One lossless UTC spelling for the contract's valid timestamp forms. Fractional
 * precision is preserved while insignificant trailing zeroes are removed.
 */
export function canonicalizeIsoDateTime(value) {
    const match = isoDateTime.exec(value);
    const instant = Date.parse(value);
    if (match === null || !Number.isFinite(instant) || new Date(instant).toISOString().slice(0, 19) !== match[1]) {
        throw new CanonicalizationError("Timestamp is not a valid UTC contract date-time");
    }
    const fraction = (match[2] ?? "").replace(/0+$/, "");
    return `${match[1]}${fraction === "" ? "" : `.${fraction}`}Z`;
}
export const Sha256Schema = Type.String({ pattern: "^[a-f0-9]{64}$" });
export const IdempotencyKeySchema = Type.String({ minLength: 8, maxLength: 128, pattern: "^[A-Za-z0-9][A-Za-z0-9._:-]*$" });
export const JsonObjectSchema = Type.Record(Type.String(), Type.Unknown());
//# sourceMappingURL=primitives.js.map